module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAAsklEQVQ4ja2UsQ3CMBBFX1CmoAClygq0rMEirABLBTpYgQ4KYIyPDhywDBaHw5euyFl5/vcdp5JEpBY4UKhRAupKQXeZM0mtpLMeorTqyNE48JdOH+u0YZntgFnBUFXaMGcLYAtMcju6FfJpJJ2GZhY/9MBfAE0O9rboqGP8TvFIoRQD60y23s/DNAU2wDy9Tr0+Nr9on4OtnIB+gqs5+0dml3AdBx/AE2SVG9Or1y8LuAF5+LUYmwem1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/change.png
// module id = 177
// module chunks = 0